import { render, staticRenderFns } from "./BuddhismTablets.vue?vue&type=template&id=1eca21ec&scoped=true"
import script from "./BuddhismTablets.vue?vue&type=script&lang=js"
export * from "./BuddhismTablets.vue?vue&type=script&lang=js"
import style0 from "./BuddhismTablets.vue?vue&type=style&index=0&id=1eca21ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eca21ec",
  null
  
)

export default component.exports